<span class="inline-block align-middle">
  <span
    *ngIf="node"
    class="!bg-{{
      getTopLevelTag(node)?.color === 'white'
        ? 'gray'
        : getTopLevelTag(node).color
    }}-300 !text-white w-[20px] h-[20px] mr-2 rounded-md flex items-center justify-center {{
      getTopLevelTag(node)?.color
    }}"
    [ngSwitch]="getTopLevelTag(node)?.summary"
  >
    <mat-icon
      class="align-middle  !text-{{
        getTopLevelTag(node)?.color
      }}-800 !text-sm !w-auto !h-auto"
      *ngSwitchCase="'expenditureProgress'"
      >shopping_bag</mat-icon
    >
    <mat-icon
      class="align-middle !text-sm !w-auto !h-auto"
      *ngSwitchCase="'incomeProgress'"
      >savings</mat-icon
    >
    <mat-icon
      class="align-middle !text-sm !w-auto !h-auto"
      *ngSwitchCase="'runningBalance'"
      >balance</mat-icon
    >
    <mat-icon class="align-middle !text-sm !w-auto !h-auto" *ngSwitchDefault
      >tag</mat-icon
    >
  </span>
</span>
